<template lang="pug">
.maincontain#about.container
  .about__intro
    .about__title.d-none.d-lg-block {{ $t('shared.CLAB') }}  {{ $t('about.subtitle') }}
    .about__title.d-lg-none {{ $t('shared.CLAB') }}
      br
      | {{ $t('about.subtitle') }}
    .about__text {{ $t('about.content') }}
  .about__team(
    v-for="(item,index) in infoData"
    :key="index"
  )
    .d-flex.flex-row.flex-lg-row.flex-column
      .team
        .team.d-flex.justify-content-center.justify-content-lg-end.align-items-center
          .team__name
            .team__name--title {{ item[`jobTitle_${localeLang}`] }}
            .team__name--name {{ item[`name_${localeLang}`] }}
          img.team__img(:src="item.img")
      .content
        .about__title--subtitle {{ item[`title_${localeLang}`] }}
        MoreInfoRead
          template(v-slot:moreBlock)
            .about__text(v-html="item[`content_${localeLang}`]")
</template>

<script>
import MoreInfoRead from "@/component/MoreInfoRead.vue";

export default {
  name: "artwork",
  components: {
    MoreInfoRead,
  },
  data() {
    return {
      infoData: [
        {
          jobTitle_zh: "策展人",
          name_zh: "蔡宏賢",
          img: require(`@/assets/images/about-curator-1.png`),
          title_zh: "如何認知、理解與面對未來？",
          content_zh:
            "從物理、哲學、心理、宗教、文化與藝術層面，人們帶著全然迥異的認知與態度去面對未來，最終人類將往何處去？對於未來的想望，反映出多樣的平行未來世界觀與創造。臺灣當代文化實驗場「C-LAB未來媒體藝術節」，以過去、現下與未來的科技藝術創作，演繹出未來的奇觀異景。<br>神人化的賽伯格、數位威權夾縫中的喘息、太空殖民的異托邦等未來景致，究竟是人類文明科技巨輪滾動的命定未來，或是慾望所驅使的未來？高低起伏地表下蜿蜒流淌的河流，真實的地理資訊被人工智慧轉化爲絕美的聲響與視覺裝置作品，演算再現的自然，可能成為未來人工智慧審美觀的運算標準之一。<br>當數據與參數成為未來人們演算與再造各種模型的基礎，純粹的視覺作品轉換為全球政治、社會與經濟議題抗爭的動態宣傳媒體工具。網路傳遞著蓄意的錯誤訊息與深偽技術的影片，人類的隱私、行為模式被系統存取濫用，科技霸權與國家巨獸控制了資訊的流向與記憶的存取。人臉辨識偵測系統檢查候選人的愛國之心時，人工智慧的機器變成中選會的候選資格審核機器，未來將剩下多少真實的人權、自由、民主？<br>我們正生活在與威權爭奪數位記憶的戰爭中，記憶是如何被植入與存取？現在與未來所能遺留殘存下的記憶，哪些才是真實留存的？人們逐漸接受數位威權控制下的生活，消費足跡、生理偵測與隱私被赤裸攤開操弄之時，失重下的人們該如何相抗排毒？去中心、反威權控制的區塊鏈與數位貨幣逐漸發展出全新數位創作的買賣機制，並屢創新高，究竟是未來新契機或被資本吞噬？<br>如同1929年班納爾（J.D. BERNAL）的未來經典《世界，肉體，惡魔》所述，人類如惡魔般擁有不完美的精神狀態，卻掌控了超越生物肉身結構侷限，到達地外世界的科技力。面對各種幽暗的威脅，保有一絲光明的希望，我們就能改變未來。臺灣在發展科技藝術、新媒體藝術的進程中想像未來，相信自由、開放與分享的開源社群，省思媒體與開放軟硬體，跨域協作與多樣性的實驗創作，透過無數次講座、論壇與工作坊的積累，開創了臺灣科技藝術的多樣生態環境，「C-LAB未來媒體藝術節」的核心價值與力量即在於此。",
          jobTitle_en: "Curator",
          name_en: "Escher TSAI",
          title_en: "How to Perceive, Understand, and Confront the Future(s)?",
          content_en:
            "Across numerous sectors including physics, philosophy, psychology, religion, arts and culture, people are now looking at the future(s) in a different light with new ideas and fresh attitudes. Where is humanity headed? Our longings for future possibilities reflect the view of multifarious paralleled futures and their making. By including past, ongoing, and forthcoming projects that combine art and technology, the Future Media Arts Festival at C-LAB presents the wonders of possible future(s).<br>Deified cyborg, struggles under the overwhelming digital authoritarianism, future scenes of heterotopias in outer-space colonies. Does the spin of the great wheel of civilization and technology determine our future(s) or is human desire the drive to shape it/them? Winding rivers run through rolling hills and rough terrains. Actual geographical data is transformed by AI algorithms into a breath-taking artwork with audio and visual installations. It is nature reinvented through computing, which helps establish future computational criteria for AI to set beauty standards.<br>When data and parameters become part of the foundation for computing and remaking different types of models in the future, a simple visual work can be subtly replaced with media propaganda in a dynamic form for promoting global political and socio-economic disputes and protests. Deliberate misinformation and deep fake videos are ubiquitous online. The system succeeds in accessing and misusing people’s privacy and information about their behavioral patterns. The technological hegemony and the monstrous state control the flow of information and our access to memories. When facial recognition is utilized to detect a person’s patriotism and AI machines take over the Central Election Commission to censor a candidate’s eligibility, how much authenticity of human rights, freedom, and democracy is left?<br>We are at war with an authoritarian system for the right to own our digital memories. How are memories implanted and accessed? Among the memories that can be preserved now and later, which are truthfully recorded? People gradually come to terms with the reality in which life is smothered by digital authoritarian control. When one’s consumer footprints, physiological data, and private information are all exposed and manipulated, how do people under such an overwhelming pressure resist against or expel the domination like detoxifying harmful substances? The decentralized, anti-authoritarian blockchain technology and digital currencies institute a new mechanism for purchasing and selling digital artworks, which keeps on thriving. Is this, after all, a crucial turning point for humanity’s future, or is it going to be assimilated with capital (mechanisms) eventually?<br>As illustrated in J.D. BERNAL’s The World, the Flesh & the Devil (1929), humans and devils alike are not always in their right minds. With such an imperfection, they however gain the technological power to reach outer space—an indication of overcoming the limitation of biological bodies. With a faint hope glowing in the blackness, we can face the darkest threats and change our future(s). During the journey of promoting digital art, art and technology, and new-media art, the Taiwanese community speculates about the future(s), believes in the open-source culture that advocates freedom, openness, and sharing, reflects on the open access to software and hardware, as well as collaborates with other disciplines to experiment with varied creative production. With countless talks, forums, and workshops, our effort has come together to nurture a flourishing heterogeneous ecology of Taiwanese digital art (art and technology), in which lie the core values and compelling power of ​​the Future Media Arts Festival at C-LAB."
        },
        {
          jobTitle_zh: "策展人",
          name_zh: "吳達坤",
          img: require(`@/assets/images/about-curator-2.png`),
          title_zh: "探測未來：C-LAB未來媒體藝術節",
          content_zh: `C-LAB自2018年啟動以來，即不斷透過各項計畫實驗創新，培育創意人才，已成為臺灣科技藝術發展的重要加速器。今年在C-LAB首度舉辦的「未來媒體藝術節」將以「未來學」作為方法，探究藝術總體軸線。以人類面對未知的無窮渴望，回應未來的種種驚奇。
          <br>
          1943年，由德國學者奧西普．弗萊西泰姆 （Ossip K. FLECHTHEIM） 率先提出「未來學」（Futurology）做跨學科統合領域的推測學門，對於社會、科學、技術史、經濟、軍事的發展進行預測。也影響後世許多藝術家針對過去、當下與未來進行創作，科幻小說與電影創作也提供生動、富有魅力的未來願景。「未來」視為此次C-LAB核心主題的媒體藝術節，策展團隊以線上/線下實體展覽建構出科技藝術方法學的取樣，邀集23組藝術家們的作品文本在此呈現；並加入未來視覺實驗室FUTURE VISION LAB計畫、PCD/TTD/PAD系列講座與工作坊，以三大塊面共構出「C-LAB未來媒體藝術節」的多層次策展架構。
          <br>
          若說COVID-19為全球迎來真正屬於二十一世紀的第一起事件，或許人類也正迎向新的科技奇點（Singularity）爆炸轉變。當社交媒體和網絡改變接受訊息和反應的方式，演算法與機器學習也帶來深偽造假的認知提問。假新聞、AI人工智慧、奈米晶片、生物科技、機端氣候、區塊鏈、NFT、演算視覺與太空星際探索已是人類的現在進行式，在未來，甚至賽伯格社會與時空旅行都將可能成為日常。藝術家總是能在時空的縫隙中開闢蹊徑，將創作連結議題納入思考，整合哲學、物理、文化與社會趨勢作為推測基礎，我們能否相信自由及新秩序所提供的多重參照路徑？歷史上瘟疫、戰爭、天災對人類的考驗從未曾停歇。面對持續而來的挑戰，人類是否還能以當今視角去預測未知？成為超越時間的形而上存在？而人類如何以內心的良知來審視未來？

          軟體學家艾倫‧凱 （Alan KAY）這句話是最積極的解答：「預測未來最好的方法就是創造未來。」（The best way to predict the future is to invent it.`,
          jobTitle_en: "Curator",
          name_en: "WU Dar-Kuen",
          title_en: "Venturing into the Future(s): The Future Media Arts Festival at C-LAB",
          content_en: 
            "Since the inception of C-LAB in 2018, the team has been striving to promote experimental innovations and foster new creative talents by conducting various programs. It has henceforth become an important incubator for accelerating the developments in art and technology in Taiwan. This year, the fresh start of the Future Media Arts Festival at C-LAB adopts “futurologist” approaches to examine art in relation to the big picture. With humanity’s boundless longings for the unknown, the exhibition responds to the serendipity of future possibilities.<br>In 1943, “futurology” was coined by a German scholar, Ossip K. FLECHTHEIM, to describe a discipline that integrates different fields of studies to make speculations and to forecast future trends in society, science, technological developments, the economy, and the military. Inspired by futurology, many artists speculate about the past, the present, and the future in their artistic practices. Innumerable sci-fi novels and films also put forward vigorous and fascinating visions for the future(s). Seeing “future” as a core theme, the curatorial team decides to implement the Future Media Arts Festival at C-LAB in the form of combined online/offline exhibitions—with the intention to enrich the artistic reservoir of art and technology and contribute to the consolidation of relevant methodology. 23 groups of artists are invited to present their works and contextualize them in the big picture. Furthermore, the FUTURE VISION LAB Project and the PCD/TTD/PAD Talk and Workshop Series are held alongside the Future Media Arts Festival, constituting three major sections of this annual event and addressing the multilayered complexity of the curatorial attempt.<br>If the COVID-19 pandemic is considered the first real incident faced by the global community in the 21st century, perhaps humanity is headed towards explosive transformations of new technological singularity. Social media and networks have changed how information is received and responded to; algorithms and machine learning pose important questions about cognition in the face of deepfake fabrication. Fake news, artificial intelligence (AI), nanochips, biotechnology, extreme weathers, blockchain, NFT, computed visualization, and intergalactic space explorations are all in progress. In the future, cyborg society and spacetime travel may even become a daily reality. Forging new paths in the cracks of space and time is made possible when artists connect the dots in philosophy, physics, cultures, and social trends, based upon which further in-depth consideration is conducted. Can we believe in the multiple referential trajectories in freedom and in the new order? The challenges of plagues, wars, and natural catastrophes inflicting on human beings have never ceased to exist in history. Seeing one after another challenge, can humanity still predict the unknown with the current visions? Can we become beings that transcend time? How does humanity reflect on the future(s) with its inner conscience?<br>It is best answered by computer scientist, Alan KAY, who proactively argues that “the best way to predict the future is to invent it.”"
        },
      ],
    };
  },
  computed: {
    localeLang() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="sass" scoped>
// *
//   border: solid 1px red
#about
  max-width: 900px
  margin-top: 152px
  margin-bottom: 90px
  +rwd-md
    padding: 0 15px
    width: 100%
    max-width: none
    margin-top: 83px

.about
  &__intro
    margin-bottom: 60px
    +rwd-md
      margin-bottom: 14px

  &__title
    font-family: "Noto Sans TC", Arial, Helvetica, sans-serif
    font-size: 36px
    font-weight: 900
    text-align: center
    margin-bottom: 38px

    +rwd-md
      font-size: 24px
      font-weight: 700
      margin-right: auto
      margin-left: auto
      margin-bottom: 14px


    &--subtitle
      font-size: 18px
      font-weight: 700
      text-align: left
      margin-bottom: 13px

  &__text
    font-weight: 400

  &__team
    margin-bottom: 90px

    +rwd-md
      padding: 0 15px
      margin-bottom: 13px
      margin-left: -15px
      margin-right: -15px
      background-color: #F8F8F8

.team
  position: relative
  width: 288px
  +rwd-md
    padding-left: 20px
    margin: 12px auto

  &__name
    position: absolute
    z-index: 2
    left: 0
    max-width: 120px
    +rwd-md
      width: 100%
      left: 50%
      transform: translateX(-104px)

    &--title
      font-size: 18px
      font-weight: 700
      +rwd-md
        font-size: 14px
        font-weight: 400

    &--name
      letter-spacing: -0.05em
      font-size: 37px
      font-weight: 700
      +rwd-md
        font-size: 24px

  &__img
    width: 100%
    max-width: 200px
    +rwd-md
      max-width: 105px

.content
  padding-left: 35px
  +rwd-md
    padding: 0

  .about__text
    font-family: "Noto Sans TC", Arial, Helvetica, sans-serif
    line-height: 24px
</style>
